import "../components/html-panel";
import "../components/alert/alert";

import CCCHtmlPanel from "../components/html-panel";
import { getDomElement } from "../core/utilities";
import OContentModel from "../models/OContentModel";
import CCCAlert from "../components/alert/alert";

export interface EventReplayVideoControllerOptions {
  container: string;
  discussionId: string;
  isEditOrCreateMode?: boolean;
}

export default class EventReplayVideoController {
  protected $eventDetailsContainer: HTMLElement = null;
  protected $separatorElement: HTMLElement = null;
  protected $htmlContainer: CCCHtmlPanel = null;

  async init(opts: EventReplayVideoControllerOptions): Promise<void> {
    console.log("EventReplayVideo controller.");

    if (opts.isEditOrCreateMode) return;

    this.$eventDetailsContainer = getDomElement(opts.container);

    let alert = document.createElement("ccc-alert") as CCCAlert;

    alert.style.display = "block";
    alert.style.margin = "20px 0";

    if (this.$eventDetailsContainer) {
      try {
        const dates = document.querySelectorAll("time");
        const endDate = Date.parse(dates[1].dateTime);
        const currentDate = Date.now();

        if (endDate && currentDate > endDate) {
          // load video
          const videoString = await OContentModel.getEventVideoReplay(
            opts.discussionId
          );

          if (videoString !== "") {
            // create separator
            this.$separatorElement = this.createSeparator();

            // add video
            this.addVideo(videoString);

            alert = null;
          } else {
            console.log(
              "  EventReplayVideo - No video found for id: %s.",
              opts.discussionId
            );

            this.$eventDetailsContainer.appendChild(alert);
            alert.setState({
              text: "We’re working on the replay, please check back soon!",
              type: "info",
            });
          }
        }
      } catch (err) {
        this.$eventDetailsContainer.appendChild(alert);
        alert.setState({
          text: "Note: If a replay video is not loading, try refreshing the page or clear your browser cache/cookies. If that does not work, try using a different browser (there have been reported issues on Chrome.)",
        });
        console.error(err);
      }
    } else {
      console.log("  EventReplayVideo - Selector not found.");
    }
  }

  private addVideo(video: string) {
    if (this.$eventDetailsContainer && this.$separatorElement) {
      // load video
      this.$htmlContainer = document.createElement(
        "ccc-html-panel"
      ) as CCCHtmlPanel;
      this.$eventDetailsContainer.appendChild(this.$htmlContainer);
      this.$eventDetailsContainer.appendChild(this.$separatorElement);
      setTimeout(() => {
        this.$htmlContainer.setKeyState("html", video);
        this.$htmlContainer.loading = false;
      }, 2000);
    }
  }

  private createSeparator(): HTMLElement | null {
    const separator = document.createElement("div");
    separator.setAttribute("class", "videoReplaySeparator");
    separator.setAttribute(
      "style",
      "border-bottom: 1px solid rgb(208, 208, 208); padding-top: 20px; padding-bottom: 20px;"
    );
    return separator as HTMLElement;
  }
}
